// Получение options для компонента Select

import { SelectProps } from "antd";

type Props<T> = {
  list: T[] | undefined;
  valueName?: keyof T;
  labelName?: keyof T;
  disableRule?: (option: T) => boolean;
  renderTitle?: (option: T) => string;
  className?: string;
  style?: { [key: string]: string };
};

export const getSelectOptions = <T extends object>(props: Props<T>): SelectProps<T>["options"] => {
  const {
    list,
    valueName = "id",
    labelName = "name",
    disableRule,
    renderTitle,
    className,
    style,
  } = props;
  return (
    list?.map((option) => {
      const disabled = disableRule ? disableRule(option) : undefined;
      const title = renderTitle ? renderTitle(option) : undefined;
      return {
        option,
        // @ts-ignore
        label: option?.[labelName],
        // @ts-ignore
        value: option?.[valueName],
        disabled,
        className,
        style,
        title,
      };
    }) || []
  );
};
